export default function mpsToKmph(mps) {
  return mps * 3.6
}
